import traverse from 'json-schema-traverse'
import * as Strings from '@avcan/utils/string'

// Gets a subschema from the base schema for a given name
export function get(schema, name) {
    const running = []
    let subschema = null

    const callbacks = {
        cb: {
            pre(schema, pointer, root, parentPointer, parentKeyword, parentSchema, property) {
                if (property !== undefined && subschema === null) {
                    running.push(property)

                    if ('$ref' in schema) {
                        const definitions = Object.values(root.definitions)
                        function find({ $id }) {
                            return $id === schema.$ref
                        }

                        traverse(definitions.find(find), callbacks)
                    }

                    if (Strings.fromPath(running) === name) {
                        throw {
                            schema,
                            pointer,
                            root,
                            parent: parentSchema,
                            property,
                            parentPointer,
                            parentKeyword,
                            path: [...running],
                            name,
                        }
                    }
                }
            },
            post(schema, pointer, root, parentPointer, parentKeyword, parentSchema, property) {
                if (property !== undefined) {
                    running.pop()
                }
            },
        },
    }

    traverse(schema, callbacks)
}
